import { MercuryEvents } from "../../../services/types";
import PublicApiService from "../../../services/PublicApiService";

class EventsHelper {
  private _mercuryEvents: MercuryEvents[] = [];

  get mercuryEvents(): MercuryEvents[] {
    return this._mercuryEvents;
  }

  async fetchMercuryEvents() {
    const eventsResponse = await PublicApiService.getSupportedMercuryShows();
    this._mercuryEvents = eventsResponse.eventEditions;
  }
}

export default new EventsHelper();
